import { NavItemWrapper, NavWrapper } from '@nkr/views/center-admin/styles';
import { Badge, Glyphicon, Nav } from 'react-bootstrap';
import { IPreselectsCount } from './models/index';
import { PreSelectSubSection } from '@nkr/enums/index';

interface IProps {
    centerId: number,
    activeTab: PreSelectSubSection,
    data: IPreselectsCount,
    showBusy: boolean,
    onTabChange: (tab: PreSelectSubSection) => void
}

const SubSectionFilters = (props: IProps) => {
    const tabWidth = '230';
    const counts = props.data;

    return (
        <NavWrapper verticalAlign='center' minTabWidth='85' fontSize='12px' style={{ marginBottom: 5 }}>
            <div style={{ width: '84%' }}>
                <Nav bsStyle='pills' activeKey={props.activeTab} className='acc-pills' onSelect={(e: any) => props.onTabChange(e)}>
                    <NavItemWrapper eventKey={PreSelectSubSection.All} tabWidth={tabWidth}>
                        All <Badge>{counts.all}</Badge>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSubSection.Pending} tabWidth={tabWidth}>
                        Pending <Badge>{counts.pending}</Badge>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSubSection.Accepted} tabWidth={tabWidth}>
                        Accepted <Badge>{counts.accepted}</Badge>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSubSection.Declined} tabWidth={tabWidth}>
                        Declined <Badge>{counts.declined}</Badge>
                    </NavItemWrapper>
                </Nav>
            </div>

            <div style={{ width: '7%', textAlign: 'right', paddingRight: 5 }}>
                {props.showBusy && (
                    <Glyphicon glyph='time' style={{ lineHeight: '20px' }} />
                )}
            </div>

        </NavWrapper>
    );
}

export default SubSectionFilters;